var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.282,
    height: 92.266,
    viewBox: "0 0 92.282 92.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contract",
    transform: "translate(0 -0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_217",
    "data-name": "Trac\\xE9 217",
    d: "M247.268,99.437a4.616,4.616,0,0,0-8.458-1.108l-.769,1.338a1.538,1.538,0,0,0-2.091.554l-3.906,6.658-1.338-.769a1.536,1.536,0,1,0-1.538,2.66l1.338.769-13.071,22.651-3.229,8.627-1.538,2.875a4.614,4.614,0,0,0,.246,4.983l-3.46,4.244-.969-2.429a3.076,3.076,0,0,0-5.49-.431l-.553.938-.523-6.151a3.076,3.076,0,0,0-5.982-.722l-3.783,11.349a1.538,1.538,0,0,0,.969,1.938,1.332,1.332,0,0,0,.477.122,1.538,1.538,0,0,0,1.461-1.045l3.767-11.349.538,6.243a3.076,3.076,0,0,0,5.705,1.323l.569-.939.954,2.415a3.075,3.075,0,0,0,5.259.784l3.583-4.536a4.738,4.738,0,0,0,1.215.154,4.614,4.614,0,0,0,4.013-2.277l1.538-2.568,5.859-7.12,13.209-22.928,1.338.769a1.542,1.542,0,0,1,.569,2.107l-6.151,10.657a1.527,1.527,0,1,0,2.6,1.6l6.151-10.657a4.612,4.612,0,0,0-1.692-6.305l-1.338-.769,3.844-6.659a1.538,1.538,0,0,0-.553-2.091l.769-1.338a4.612,4.612,0,0,0,.461-3.567Zm-5.8.43a1.538,1.538,0,0,1,.939-.722,1.615,1.615,0,0,1,1.168.154,1.539,1.539,0,0,1,.723.938,1.615,1.615,0,0,1-.154,1.168l-.769,1.338-2.676-1.538ZM220.511,142.8l-.769-.446-2.276-1.323,2.184-5.843,4.844,2.8Zm-4.613,4.444a1.537,1.537,0,0,1-.461-2.015l.769-1.337,2.675,1.538-.769,1.322a1.537,1.537,0,0,1-2.214.492Zm10.349-11.779-5.321-3.076,12.3-21.314,5.321,3.076Zm13.84-23.974-5.321-3.076,3.076-5.321,5.321,3.076Zm0,0",
    transform: "translate(-155.155 -77.531)",
    fill: "#329aec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_218",
    "data-name": "Trac\\xE9 218",
    d: "M78.639,356.966,73.2,362.395l-3.26-3.26a1.539,1.539,0,1,0-2.169,2.184l3.26,3.26a3.1,3.1,0,0,0,4.352,0l5.428-5.444a1.538,1.538,0,0,0-2.168-2.169Zm0,0",
    transform: "translate(-54.373 -288.019)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_219",
    "data-name": "Trac\\xE9 219",
    d: "M32,325.112a13.071,13.071,0,1,0,26.142,0,1.538,1.538,0,0,0-3.076,0,10,10,0,1,1-4-8,1.538,1.538,0,0,0,1.846-2.461A13.071,13.071,0,0,0,32,325.112Zm0,0",
    transform: "translate(-25.849 -252.029)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_220",
    "data-name": "Trac\\xE9 220",
    d: "M113.52,51.115a1.538,1.538,0,1,0,0-3.076H73.538A1.538,1.538,0,0,0,72,49.577v6.151a1.537,1.537,0,0,0,1.538,1.538H113.52a1.538,1.538,0,1,0,0-3.076H75.076V51.115Zm0,0",
    transform: "translate(-58.16 -38.773)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_221",
    "data-name": "Trac\\xE9 221",
    d: "M97.538,112.039a1.538,1.538,0,0,0,0,3.076h30.755a1.538,1.538,0,0,0,0-3.076Zm0,0",
    transform: "translate(-77.547 -90.471)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_222",
    "data-name": "Trac\\xE9 222",
    d: "M163.369,168.039H129.538a1.538,1.538,0,1,0,0,3.076h33.831a1.538,1.538,0,0,0,0-3.076Zm0,0",
    transform: "translate(-103.396 -135.707)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_223",
    "data-name": "Trac\\xE9 223",
    d: "M89.831,217.577a1.538,1.538,0,0,0-1.538-1.538H57.538a1.538,1.538,0,0,0,0,3.076H88.293A1.537,1.537,0,0,0,89.831,217.577Zm0,0",
    transform: "translate(-45.236 -174.48)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_224",
    "data-name": "Trac\\xE9 224",
    d: "M260.3,216.039H249.538a1.538,1.538,0,0,0,0,3.076H260.3a1.538,1.538,0,0,0,0-3.076Zm0,0",
    transform: "translate(-200.329 -174.48)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_225",
    "data-name": "Trac\\xE9 225",
    d: "M72.916,259.115a1.538,1.538,0,0,0,0-3.076H57.538a1.538,1.538,0,0,0,0,3.076Zm0,0",
    transform: "translate(-45.236 -206.791)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_226",
    "data-name": "Trac\\xE9 226",
    d: "M169.538,259.115H180.3a1.538,1.538,0,1,0,0-3.076H169.538a1.538,1.538,0,1,0,0,3.076Zm0,0",
    transform: "translate(-135.707 -206.791)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_227",
    "data-name": "Trac\\xE9 227",
    d: "M69.2,70.777a1.538,1.538,0,0,0-1.538,1.538V87.692a1.537,1.537,0,0,1-1.538,1.538H4.613a1.537,1.537,0,0,1-1.538-1.538V4.652A1.538,1.538,0,0,1,4.613,3.115H66.124a1.538,1.538,0,0,1,1.538,1.538v28.88a1.538,1.538,0,1,0,3.076,0V4.652A4.614,4.614,0,0,0,66.124.039H4.613A4.614,4.614,0,0,0,0,4.652v83.04a4.613,4.613,0,0,0,4.613,4.613H66.124a4.613,4.613,0,0,0,4.613-4.613V72.314A1.538,1.538,0,0,0,69.2,70.777Zm0,0",
    fill: "#252551"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.5bc6f20fccbe8ed01b2fffa540420d3c.svg";
export { ForwardRef as ReactComponent };